var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-scale-wrap",style:(_vm.wrapStyle)},[_c('div',{staticClass:"video-scale",style:(_vm.videoStyle)},[_c('VideoPlayer',{ref:"playerRef",on:{"tagChange":_vm.tagChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }